import type { PageFaq } from "@/lib/pages";
import { RoundupLandingPage } from "@/components/compare-landing/roundup-landing-page";
import { monarchAlternativesConfig } from "./compare-monarch-alternatives-config";

/**
 * Config-driven roundup landing page for `/compare/monarch-alternatives`.
 * Both locale entry routes render this component; its SEO meta comes from the
 * locale-aware markdown frontmatter in `pages/compare/monarch-alternatives.md`
 * via the sibling `compare-monarch-alternatives.meta.ts`.
 */
export function MonarchAlternativesComponent({
  faqs,
  offersAsOf,
}: {
  faqs?: PageFaq[];
  offersAsOf: string;
}) {
  return (
    <RoundupLandingPage
      config={monarchAlternativesConfig}
      faqs={faqs}
      offersAsOf={offersAsOf}
    />
  );
}
